// extracted by mini-css-extract-plugin
export default {"teamtitle":"ThirdBox_teamtitle__dOD6D","teambox":"ThirdBox_teambox__w6HId","teamdesc":"ThirdBox_teamdesc__Q43T8"};